import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Page Components
import Home from './components/Home';
//import HowItWorks from './components/HowItWorks';
import Koffieland from './components/koffieland/Koffieland';
import Technology from './components/technology/Technology';
import Solutions from './components/Solutions/Solutions';
import ApiHome from './apiv2/apimain';


function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          
          <Route path="/solutions" element={<Solutions/>} />
          <Route path="/technology" element={<Technology/>} />
          <Route path="/koffieland" element={<Koffieland/>} />
          <Route path="digibeanapi" element={<ApiHome />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;